export default "__VITE_ASSET__BAU3CXXN__"